var l = /* @__PURE__ */ ((d) => (d.VisuallyHidden = "VisuallyHidden", d.TotallyHidden = "TotallyHidden", d))(l || {}), i = /* @__PURE__ */ ((d) => (d.VisuallyHidden = "iress-sr-only", d.TotallyHidden = "iress-hidden", d))(i || {});
export {
  i as HideCssClass,
  l as HideTypes
};
